(function(){
    'use strict'

    angular.module('app.grupos')
    .factory('GruposService', GruposService);

    GruposService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function GruposService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update: update,
            remove: remove
        };

        return api;

        function getAll(){

            var url = apiSettings.apiBaseUrl + 'api/grupos';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(grupoId){

            var url = apiSettings.apiBaseUrl + 'api/grupos/' + grupoId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(grupo){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/grupos',  
                method: 'POST',  
                data: grupo
            });  
            return response;
        };

        function update(grupo){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/grupos',  
                method: 'PUT',  
                data: grupo
            });  
            return response;
        };

        function remove(grupo){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/grupos',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: grupo
            });  
            return response;
        };

    };

})();